import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { ValidatedTextField } from '../../../../../validations/validated-text-field.component'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { ValidatedDateTextField } from '../../../../../validations/validated-date-text-field.component'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../../../../portalglobals'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import * as moment from 'moment'
import { SubmitEnrollmentDataResponse } from '../../../../models/submit-enrollment-data-response'
import { EnrollmentCacheData } from '../../../../models/EnrollmentCacheData'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../../models/get-enrollment-data-response'
import { RaceEthnicityComponent } from '../../../../components/common/race-ethnicity.component'
@Component({
    selector: 'PhoneEnrollmentSpanishStep2',
    templateUrl: 'phone-enrollment-step2.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentSpanishStep2Component implements OnInit {
    private _raceEthnicityComponent: RaceEthnicityComponent
    notBlankValidator = new NotBlankGenericFieldValidator()
    //public rblRep: ValidatedRadioButtonModel[] = []
    //public rdlHMO: ValidatedRadioButtonModel[] = []
    public rblBenf: ValidatedRadioButtonModel[] = []
    validatedDate = new ValidatedDateTextField()
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    //public IsRblRepYes: boolean
    //public IsRblRepNo: boolean
    //public IsRdlHMOYes: boolean
    public showError: boolean = false
    // public MedicareNum: ValidatedRadioButtonModel[] = []
    public IsrblBenfYes: boolean
    public IsrblBenfNo: boolean
    public showsubmit: boolean
    hasError: boolean
    ErrorMessages: any[]
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyourhisher: string
    spnyouhimher: string
    spnIsBeneficiaryYou: string
    spnIsEmployeeYour: string
    spnYourenrollee: string
    spnenrolled: string
    spncalifica: string
    AgentFullName: string
    showHover: boolean = false
    insuranceComapny: string
    public loading: boolean = false
    checkPlanyear: boolean = false
    isQtip: boolean
    ShowCurrentYearScript: boolean = false
    isAEPVisible: boolean = false
    reasonCode: string = ''
    periodSelected: string = ''
    disableEffectiveDate: boolean = false
    dateField: boolean = false
    rblvalidPeriod: ValidatedRadioButtonModel[] = []
    IsRblvalidPeriodYes: boolean
    IsRblvalidPeriodNo: boolean
    visibleFrom2025: boolean

    constructor(public _global: PortalGlobals, private router: Router, private _enrollementGateway: EnrollmentGateway) {
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollementGateway)
        //this.rblRep.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        //this.rdlHMO.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblBenf.push({ value: 'Yes', htmlLabel: 'Si' }, { value: 'No', htmlLabel: 'No' })
        this.rblvalidPeriod.push({ value: 'Yes', htmlLabel: 'Si' }, { value: 'No', htmlLabel: 'No' })

        //this.IsRblRepYes = false
        //this.IsRblRepNo = false
        //this.IsRdlHMOYes = false

        this.IsRblvalidPeriodYes = false
        this.IsRblvalidPeriodNo = false
        this.showsubmit = false

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        } else {
            this.ShowCurrentYearScript = false
        }
    }
    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)
        if (this.enrollment === null || this.enrollment === undefined) {
            this.router.navigate([
                '/' +
                    insCo +
                    '/enrollment/phone-enrollment/spanish/Step1/' +
                    this.enrollmentCacheData.CALLOGID +
                    '/' +
                    this.enrollmentCacheData.PlanYear
            ])
        }
        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                        this.enrollment.CALLOGID = this.enrollmentCacheData.CALLOGID
                        this.enrollment.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                        this.enrollment.RBLBENFE = this.enrollmentCacheData.RBLBENFE

                        this.LoadData()
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate([
                    '/' + insCo + '/enrollment/phone-enrollment/spanish/Step1/' + this.enrollment.CALLOGID + '/' + this.enrollment.PLANYEAR
                ])
            }
        } else {
            this.LoadData()
        }
    }

    SalesBenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/BeneficiaryDetails/7'])
    }

    LoadData(): void {
        this.isQtip = false
        this.isAEPVisible = false
        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        if (this.enrollment.CALLOGID !== 0 && this.enrollment.CALLOGID !== null && this.enrollment.CALLOGID !== undefined) {
            this.isQtip = true
        }

        let today = new Date()
        if (this.enrollment.APPDT === null || this.enrollment.APPDT === undefined) {
            this.enrollment.APPDT = today
        }
        if (this.enrollment.RBLVALIDPERIOD !== '' && this.enrollment.RBLVALIDPERIOD !== null && this.enrollment.RBLVALIDPERIOD !== undefined) {
            this.ShowGroupOptionsEP(this.enrollment.RBLVALIDPERIOD)
        }
        if (this.enrollment.ELECTION !== '' && this.enrollment.ELECTION !== null && this.enrollment.ELECTION !== undefined) {
            this.periodSelectdChanged(this.enrollment.ELECTION)
        }

        //this.ShowGroupOptions(this.enrollment.RBLHEALTHCOVERAGE)
        //this.ShowOptionsHMO(this.enrollment.RBLHMO)
        this.ShowGroupOptionsEnrolle(this.enrollment.RBLBENEFICIARYPART)
        this.AgentFullName =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)
        this.setScript()

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true
        }
    }

    //ShowGroupOptions(isgroup: string) {
    //    if (isgroup === 'Yes') {
    //        this.IsRblRepYes = true
    //        this.IsRblRepNo = false

    //    }
    //    if (isgroup === 'No') {
    //        this.IsRblRepYes = false
    //        this.IsRblRepNo = true
    //    }
    //    this.enrollment.RBLHEALTHCOVERAGE = isgroup

    //}
    //ShowOptionsHMO(ishmo: string) {
    //    if (ishmo === 'Yes') {
    //        this.IsRdlHMOYes = true;
    //    }
    //    if (ishmo === 'No') {
    //        this.IsRdlHMOYes = false
    //    }
    //    this.enrollment.RBLHMO = ishmo

    //}
    ShowGroupOptionsEnrolle(isenrolle: any) {
        if (isenrolle === 'Yes') {
            this.IsrblBenfYes = true
            this.IsrblBenfNo = false
            //this.showsubmit = true
            if (
                this.enrollment.RBLVALIDPERIOD != null &&
                this.enrollment.RBLVALIDPERIOD != undefined &&
                this.enrollment.RBLVALIDPERIOD != '' &&
                this.enrollment.RBLVALIDPERIOD == 'Yes'
            ) {
                this.showsubmit = true
            }
        }
        if (isenrolle === 'No') {
            this.IsrblBenfYes = false
            this.IsrblBenfNo = true
            this.showsubmit = false
        }
        this.enrollment.RBLBENEFICIARYPART = isenrolle
    }
    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate([
            '/' + insCo + '/enrollment/phone-enrollment/spanish/Step1/' + this.enrollment.CALLOGID + '/' + this.enrollment.PLANYEAR
        ])
    }
    formSubmit(): void {
        this.validateForm()
    }
    validateForm() {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        if (this.enrollment.HICN === undefined || this.enrollment.HICN === '' || this.enrollment.HICN === null) {
            this.ErrorMessages.push('Número de Medicare es requerido')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        } else if (this.enrollment.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Ingrese el número de Medicare sin -')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }

        if (this.enrollment.CURRENTGENDER == '4' && (this.enrollment.CURRENTGENDEROTH == undefined || this.enrollment.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Se requiere una identidad de género diferente')
            this.hasError = true
        }
        if (this.enrollment.GENDERNPRONOUN == '4' && (this.enrollment.GENDERNPRONOUNOTH == undefined || this.enrollment.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Se requiere una identidad propia diferente')
            this.hasError = true
        }
        //if (this.enrollment.RBLHEALTHCOVERAGE === undefined || this.enrollment.RBLHEALTHCOVERAGE === ''
        //    || this.enrollment.RBLHEALTHCOVERAGE === null) {
        //    this.ErrorMessages.push('Please select health coverage')
        //    this.hasError = true
        //    this.focusableEleTop.nativeElement.focus()
        //}
        if (this.enrollment.MEDA !== undefined && this.enrollment.MEDA !== null) {
            let parta = moment(this.enrollment.MEDA).format('MM/DD/YYYY')
            if (parta === null || parta === '') {
                this.ErrorMessages.push('Fecha inválida de la Parte A')
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            }
        }
        if (this.enrollment.MEDB !== undefined && this.enrollment.MEDB !== null) {
            let partb = moment(this.enrollment.MEDB).format('MM/DD/YYYY')
            if (partb === null || partb === '') {
                this.ErrorMessages.push('Fecha inválida de la Parte B')
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            }
        }
        if (this.enrollment.ELECTION === undefined || this.enrollment.ELECTION === null || this.enrollment.ELECTION === '') {
            this.ErrorMessages.push('Estado electoral es requerido')
            this.hasError = true
        }
        if (this.enrollment.ELECTION !== undefined && this.enrollment.ELECTION !== '') {
            if (this.enrollment.SEPREASONTEXT === undefined || this.enrollment.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Criterios de inscripción es requerido')
                this.hasError = true
            }
            if (this.enrollment.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollment.SEPEFFDT === undefined || this.enrollment.SEPEFFDT === null) {
                        this.ErrorMessages.push('Fecha SEP es requerido')
                        this.hasError = true
                    }
                }
            }
        }

        if (this.enrollment.APPDT === undefined || this.enrollment.APPDT === null) {
            this.ErrorMessages.push('Fecha de aplicacion es requerido')
            this.hasError = true
        }
        if (this.enrollment.EFFDT === undefined || this.enrollment.EFFDT === null) {
            this.ErrorMessages.push('Fecha efectiva es requerido')
            this.hasError = true
        } else {
            if (this.enrollment.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('La Fecha de vigencia debe ser el primero del mes.')
                this.hasError = true
            }
            if (this.enrollment.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('La Fecha de entrada en vigencia debe ser el mismo año que el Año del plan')
                this.hasError = true
            }
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }
        if (this.enrollment.EFFDT && this.enrollment.APPDT && this.enrollment.EFFDT <= this.enrollment.APPDT) {
            this.ErrorMessages.push('Fecha de aplicacion debe ser anterior a la fecha efectiva.')
            this.hasError = true
        }
        // check authorize reprenatative
        //if (this.IsRblRepNo) {
        //    if (this.enrollment.RBLHMO === undefined || this.enrollment.RBLHMO === ''
        //        || this.enrollment.RBLHMO === null) {
        //        this.ErrorMessages.push('Please select member advantage plan')
        //        this.hasError = true
        //        this.focusableEleTop.nativeElement.focus()
        //    }

        //}

        if (!this.hasError) {
            this.saveData()
        }

        // return this.hasError
    }
    saveData() {
        //if (this.enrollment.MEDA === undefined ||
        //    this.enrollment.MEDA === null) {
        //    this.enrollment.MEDA = ''
        //}
        //if (this.enrollment.MEDB === undefined ||
        //    this.enrollment.MEDB === null) {
        //    this.enrollment.MEDB = ''
        //}
        this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollment.STEPCODE = '22'
        this.enrollment.ADMINID = this._global.currentUser.userProfileId
        this.enrollment.AGENTID = String(this._global.currentUser.userProfileId)
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        this.enrollment.INSURANCECOMPID = Number(this._global.currentUser.insuranceCompanyId)

        this.enrollment.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollment.Race)
        this.enrollment.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollment.Ethnicity)

        this.enrollment.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(this.enrollment.selectedEthnicity)
        this.enrollment.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollment.selecteRace)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollment.PLANST === '0') {
            this.enrollment.PLANST = ''
        }
        if (this.enrollment.MAILST === '0') {
            this.enrollment.MAILST = ''
        }
        if (this.enrollment.APPST === '0') {
            this.enrollment.APPST = ''
        }
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        this.loading = true
        this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
            (model: SubmitEnrollmentDataResponse) => {
                let response = model
                if (response !== undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        this.loading = false
                        this.hasError = true
                        window.scrollTo(0, 0)
                    } else {
                        if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                            this.enrollment.ENROLLKEY = response.EnrollmentKey
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                            this.loading = false

                            this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                            this.enrollmentCacheData.AgentName = this.enrollment.AGENTNAME
                            this.enrollmentCacheData.AgentID = this.enrollment.AGENTID
                            this.enrollmentCacheData.AdminID = this.enrollment.ADMINID
                            this.enrollmentCacheData.AgentOrgID = this.enrollment.AGENTORGID
                            this.enrollmentCacheData.USERNAME = this.enrollment.USERNAME
                            this.enrollmentCacheData.FORMNAME = this.enrollment.FORMNAME
                            this.enrollmentCacheData.PlanYear = this._global.selectedPlanYear
                            this.enrollmentCacheData.CALLOGID = this.enrollment.CALLOGID
                            this.enrollmentCacheData.RBLBENFE = this.enrollment.RBLBENFE

                            sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                            this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/Step3'])
                        } else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            this.hasError = true
                            this.loading = false
                        }
                        this.loading = false
                    }
                    this.loading = false
                } else {
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    this.hasError = true
                    this.loading = false
                    window.scrollTo(0, 0)
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
        //  this.router.navigate(['enrollment/phone-enrollment/Step3'])
        // }
    }
    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Will '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'usted'
            this.spnyourhisher = 'your'
            this.spnyouhimher = 'you'
            this.spnIsBeneficiaryYou = 'usted '
            this.spnIsEmployeeYour = 'your '
            this.spnYourenrollee = 'your'
            this.spnenrolled = 'inscripto'
            this.spncalifica = 'califica'
        }
        if (this.enrollment.RBLBENFE === 'No' && this.AgentFullName !== ' ' && this.AgentFullName !== 'undefined undefined') {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Will '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = this.AgentFullName
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnIsBeneficiaryYou = 'la persona inscripta '
            this.spnIsEmployeeYour = 'enrollee’s'
            this.spnYourenrollee = 'the enrollee'
            this.spnenrolled = 'inscripta'
            this.spncalifica = 'califican'
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'él'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'ella'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
            } else {
                this.spnyouheshe = '(él/ella)'
                this.spnyourhisher = '(his/her)'
                this.spnyouhimher = '(him/her)'
            }
        }
        if (this.enrollment.RBLBENFE === 'No' && (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined')) {
            this.spnIsBeneficiary = 'enrollee’s name'
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Will '
            this.spnIsAreCapt = 'Is'
            this.spnIsBeneficiaryYour = ' enrollee '
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = '(él/ella)'
            this.spnyourhisher = '(his/her)'
            this.spnyouhimher = '(him/her)'
            this.spnIsBeneficiaryYou = 'la persona inscripta'
            this.spnIsEmployeeYour = ' enrollee’s'
            this.spnYourenrollee = 'the enrollee'
            this.spnenrolled = 'inscripta'
            this.spncalifica = 'califican'
        }
    }

    toggleImage() {
        this.showHover = !this.showHover
    }

    medicareNumberValueChange(event: any) {
        this.enrollment.HICN = event.toUpperCase()
    }

    HICNBlur() {
        if (this.enrollment.HICN !== undefined && this.enrollment.HICN.indexOf('-') >= 0) {
            let re = /\-/gi
            let updatedHICN = this.enrollment.HICN.replace(re, '')
            this.enrollment.HICN = updatedHICN.toUpperCase()
        }
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    AEPVisible(event: any) {
        if (event) {
            this.isAEPVisible = true
        }
    }

    reasonCodeChanged(SelReasonCode: any) {
        this.enrollment.SEPREASONTEXT = SelReasonCode.text
        this.enrollment.ELECTIONTYPEID = SelReasonCode.id
        this.enrollment.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollment.ELECTIONTYPEID + '|' + this.enrollment.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }

    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollment.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollment.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
            this.disableEffectiveDate = true
        } else {
            if (currDate.getMonth() == 11) {
                this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollment.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollment.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear()) this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
            this.disableEffectiveDate = false
        }
    }

    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }

    sepdatechange(option: Date) {
        this.enrollment.SEPEFFDT = option
    }

    ShowGroupOptionsEP(val: any) {
        if (val === 'Yes') {
            this.IsRblvalidPeriodYes = true
            this.IsRblvalidPeriodNo = false
            this.showsubmit = true
        }
        if (val === 'No') {
            this.IsRblvalidPeriodYes = false
            this.IsRblvalidPeriodNo = true
            this.showsubmit = false
        }
        this.enrollment.RBLVALIDPERIOD = val
    }

    appRecievedDateChange(event: any) {
        this.enrollment.APPDT = event
        if (
            this.enrollment.APPDT !== undefined &&
            this.enrollment.APPDT !== null &&
            (this.enrollment.EFFDT === undefined || this.enrollment.EFFDT === null)
        ) {
            let currDate = event
            if (currDate.getMonth() == 11) {
                this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollment.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollment.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear()) this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
        }
    }
}
